@if (formGroup.get('id')?.value !== null) {
  <h3 data-test="field-details-name">
    {{ cropField.name }}
    ({{ cropField.areaInHectares }} {{ 'fields.ha' | translate }})
  </h3>
  <h4 data-test="field-details-crop">
    {{ displayCrop }}
    &nbsp;
    {{ displayCropVariety }}
  </h4>
  <h4 data-test="field-details-characteristics">
    {{ 'phosphate' | translate }} (P-AL): {{ characteristicPAL }} &nbsp;
    {{ 'phosphorus' | translate }} - P-CaCl2 (P-PAE): {{ characteristicPPAE }} &nbsp;
    {{ 'phosphate' | translate }} (Pw): {{ characteristicPw }}
  </h4>
  <div [formGroup]="formGroup" data-test="field-details-form">
    <div class="flex--row flex--responsive-gt-sm">
      <div class="flex__child">
        <div class="mat-slide-group-wrapper">
          <div class="mat-slide-group">
            <mat-slide-toggle
              color="primary"
              formControlName="shouldBeUsedInLegalStandard"
              data-test="setting-shouldBeUsedInLegalStandard"
            >
              {{ 'fields.shouldBeUsedInLegalStandard' | translate }}
            </mat-slide-toggle>
          </div>
        </div>
      </div>
      @if ((cropYear$ | async) < 2025) {
        <div class="flex__child">
          <div class="mat-slide-group-wrapper">
            <div class="mat-slide-group">
              <mat-slide-toggle
                color="primary"
                formControlName="shouldUseTransitionalArrangement"
                data-test="setting-shouldUseTransitionalArrangement"
              >
                {{ 'fields.shouldUseTransitionalArrangement' | translate }}
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      }
      @if ((cropYear$ | async) < 2025) {
        <div class="flex__child">
          <div class="mat-slide-group-wrapper">
            <div class="mat-slide-group">
              <mat-slide-toggle
                color="primary"
                formControlName="shouldUseLowInPhosphateArrangement"
                data-test="setting-shouldUseLowInPhosphateArrangement"
              >
                {{ 'fields.shouldUseLowInPhosphateArrangement' | translate }}
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      }
    </div>
    @if (getNitrogenCalculationSettingsFormGroup(formGroup)) {
      <div
        [formGroup]="getNitrogenCalculationSettingsFormGroup(formGroup)"
        data-test="nitrogen-calculation-settings"
      >
        <div class="flex--row flex--responsive-gt-sm">
          @if (settingsTogglesVisibility?.shouldShowPreviousCropCornToggle) {
            <div class="flex__child" data-test="nitrogen-calculation-toggle">
              <div class="mat-slide-group-wrapper">
                <div class="mat-slide-group">
                  <mat-slide-toggle
                    color="primary"
                    formControlName="isPreviousCropCorn"
                    data-test="setting-isPreviousCropCorn"
                  >
                    {{ 'fields.previousCropCorn' | translate }}
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
          }
          <div class="flex__child" data-test="nitrogen-calculation-toggle">
            <div class="mat-slide-group-wrapper">
              <div class="mat-slide-group">
                <mat-slide-toggle
                  color="primary"
                  formControlName="isRecoveryFertilisation"
                  data-test="setting-isRecoveryFertilisation"
                >
                  {{ 'fields.recoveryFertilisation' | translate }}
                </mat-slide-toggle>
              </div>
            </div>
          </div>
          @if (settingsTogglesVisibility?.shouldShowPreviousCropGrainToggle) {
            <div class="flex__child" data-test="nitrogen-calculation-toggle">
              <div class="mat-slide-group-wrapper">
                <div class="mat-slide-group">
                  <mat-slide-toggle
                    color="primary"
                    formControlName="isPreviousCropNotGrain"
                    data-test="setting-isPreviousCropNotGrain"
                  >
                    {{ 'fields.previousCropNotGrain' | translate }}
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
          }
          @if (settingsTogglesVisibility?.shouldShowShouldSplitNormToggle) {
            <div class="flex__child" data-test="nitrogen-calculation-toggle">
              <div class="mat-slide-group-wrapper">
                <div class="mat-slide-group">
                  <mat-slide-toggle
                    color="primary"
                    formControlName="shouldSplitNorm"
                    data-test="setting-shouldSplitNorm"
                  >
                    {{ 'fields.splitRapeSeed' | translate }}
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
          }
          @if (settingsTogglesVisibility?.shouldShowNitrogenDifferentiationToggle) {
            <div class="flex__child">
              <div class="mat-slide-group-wrapper">
                <div class="mat-slide-group">
                  <mat-slide-toggle
                    color="primary"
                    formControlName="isNitrogenDifferentiation"
                    data-test="setting-isNitrogenDifferentiation"
                  >
                    {{ 'fields.nitrogenDifferentiation' | translate }}
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="flex--row flex--responsive-gt-sm">
          @if (settingsTogglesVisibility?.shouldShowAfterTornGrassToggle) {
            <div class="flex__child" data-test="nitrogen-calculation-toggle">
              <div class="mat-slide-group-wrapper">
                <div class="mat-slide-group">
                  <mat-slide-toggle
                    color="primary"
                    formControlName="isAfterTornGrass"
                    data-test="setting-isAfterTornGrass"
                  >
                    {{ 'fields.afterTornGrass' | translate }}
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
          }
          @if (settingsTogglesVisibility?.shouldShowGrasslandUsage) {
            <div class="flex__child" data-test="nitrogen-calculation-toggle">
              <mat-form-field class="full-width-field">
                <mat-label>
                  {{ 'fields.grasslandUsage' | translate }}
                </mat-label>
                <mat-select
                  formControlName="grasslandUsage"
                  [placeholder]="'fields.grasslandUsage' | translate"
                  data-test="setting-grasslandUsage"
                >
                  @for (type of grasslandUsageKeys; track type) {
                    <mat-option [value]="type">{{ type.toLowerCase() | translate }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          <div class="flex__child flex__child-2"></div>
        </div>
      </div>
    }
  </div>
}
